// =================
//
//    Infinite scroll
//
// =================

jQuery(document).ready(function($){
  console.log($(".run-infinite-scroll-js").length);
  // data url
  // setTimeout(function(){
  //   $('[data-url]').on('click', function(e){
  //       e.preventDefault();
  //       // console.log('target = %s', $(this).attr('target'));
  //       if( $(this).attr('target') == '_blank' ) window.open( $(this).data('url') );
  //       else window.location.href = $(this).data('url');
  //   });
  //
  //   $('[data-url]').css('cursor', 'pointer');
  // });

  // activation de l'infinite scroll si les liens de pagniations sont présents
  if( $( '.run-infinite-scroll-js' ).length != 0 ) {
    // console.log( "Activation d'infint scroll");
    $( '.sfi-pagination' ).css({
      'height': '3px',
      'overflow': 'hidden'
    });
    // récupétation des paramètres de l'affichage actuel
    var pageClasses = $('body').attr('class');
    var pageActuelle = pageClasses.match(/paged-(\d+)/);
    pageActuelle = pageActuelle == undefined ? 1 : parseInt(pageActuelle[1]);
    var category = pageClasses.match(/category-(\d.)/);
    category = category == undefined ? null : category[1];
    var tag = pageClasses.match(/tag-(\d.)/);
    tag = tag == undefined ? null : tag[1];

    var loadingProgress = {};
    loadingProgress[pageActuelle+0] = 'loaded';
    var endOfPage = false;
    var noScrollWatch = false;
    var initialPageTitle = document.title.replace( /( \| Page \d)/, '');

    console.log("intialPage title = %s", initialPageTitle);

    $('.sfi-news--article').first().addClass('sfi-firstOfPage sfi-firstOfPage-' + pageActuelle);
    $('.sfi-news--article').first().attr('data-page', pageActuelle);

    $(window).scroll( function() {
      if( noScrollWatch ) return false;

      var scrollTop = $(window).scrollTop();
      var scrollBottom = scrollTop + $(window).height();


      // MAJ de l'url en fonction de la page consultée
      // ---------------------------------------------
      var currentPage = 0;
      $('.sfi-firstOfPage').each( function( index ) {
        var offsetPage = $(this).offset();
        if( offsetPage.top < scrollBottom ) {
          var page = $(this).attr('data-page');
          currentPage = parseInt(page);
        }
      });
      console.log('lecture de la page ' + currentPage);
      if( currentPage != pageActuelle && currentPage > 0 ) {
        console.log('=== Changement de page ===');
        var title = initialPageTitle + " | Page " + currentPage;
        var pagedUrl = document.location.pathname.match(/^(.+)(page\/\d+\/?$)/);
        // if(pagedUrl) {
        //   var newUrl = pagedUrl[1] + '/page/' + currentPage + '/';
        // }
        console.log(currentPage);
        var suffixUrl = currentPage == 1 ? '' : 'page/' + currentPage + '/';
        var newUrl = (pagedUrl ? pagedUrl[1] : document.location.pathname) + suffixUrl;
        var stateObj = {
          'title':  title,
          'url':    document.location.href,
          'page':   currentPage
         };
        history.pushState(stateObj, title, newUrl);
        document.title = title;
        pageActuelle = currentPage;
      }

      // chargement des pages suivantes
      // ------------------------------
      var navPos = $( '.sfi-pagination' ).offset();
      var loadingscroll = scrollBottom + 180; // +180 pour charger avant l'affichage
      // console.log( navPos );
      // console.log( scrollTop );
      if( navPos.top < loadingscroll ) {
        if( loadingProgress[pageActuelle+1] == undefined && !endOfPage ) {
          loadingProgress[pageActuelle+1] = 'loading';
          var pageLoading = pageActuelle+1;

          var container = $('.sfi-news').last();
          if(container.length == 0) {
            container = $('<div class="sfi-news sfi-news-next row"></div>');
            $('.sfi-archive-content').append(container);
            console.log(container);
          }
          $('.sfi-archive-content').append($('<div class="di-loader"><span class="fa fa-spinner fa-spin"></span></div>'));
          console.log($('.sfi-archive--select > select').children("option:selected").val());
          var cat = $('.sfi-archive--select > select').children("option:selected").val();
          if(cat == 'all') {
            cat = '';
          }
          var queryArgs = {
            'action': 'load-post-page',
            'page':   pageActuelle + 1,
            'category': cat
          }
          // console.log(queryArgs);
          $.post(
            sfi_data.ajaxUrl,
            queryArgs,
            function(data) {
              // console.log(data);
              $('.di-loader', $('.sfi-archive-content')).remove();
              var dataDom = $(data);
              dataDom.each( function(index) {
                if( $(this).hasClass('sfi-no-more-js') ) {
                  endOfPage = true;
                  return;
                }
                if( index == 0)  {
                  $(this).addClass('sfi-firstOfPage sfi-firstOfPage-' + pageLoading);
                  $(this).attr('data-page', pageLoading);
                }
                // $(this).css('opacity', 0);
                container.append(this);
                $(this).animate({'opacity': 1}, 1500);
              });
              // pageActuelle = pageLoading;
            }
          );
        }

      }
    });


    // retour historique
    // window.addEventListener( 'popstate', function() {
    //   console.log('popstate : ');
    //   console.log(history.state);
    //   document.title = history.state.title;
    //   noScrollWatch = true;
    //   smoothScroolling('.sm-firstOfPage-' + history.state.page, function() { noScrollWatch = false; /*console.log('fin de scroll');*/ });
    //   pageActuelle = history.state.page;
    //
    // });
  }

});
